(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['underscore', 'torso/modules/behaviors/DataBehavior', './imageReferenceCollection'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory(require('underscore'), require('backbone-torso/modules/behaviors/DataBehavior'), require('./imageReferenceCollection'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (_, TorsoDataBehavior, imageReferenceCollection) {
  'use strict';

  /**
   * Data behavior for the ImageReferenceCollection
   *
   * @class ImageReferenceDataBehavior
   * @constructor
   */
  return TorsoDataBehavior.extend({
    cache: imageReferenceCollection,
    renderOnFetch: true,

    /**
     * @method isEmptyImageReference
     * @param imageName {String} the name of the image to check if it has an empty reference.
     * @return {Boolean} true if the image configuration has an empty file name or the reference hasn't completed fetching.
     */
    isEmptyImageReference: function(imageName) {
      var imageReference = this.data.getModel(imageName);
      var imageReferenceFileName = imageReference && imageReference.get('fileName');
      var isEmptyImageReference = !imageReferenceFileName;
      if (_.isFunction(this.view.isPreview) && _.isFunction(this.view.isEmptyImagePreview) && this.view.isPreview()) {
        isEmptyImageReference = this.view.isEmptyImagePreview(imageName);
      }
      return isEmptyImageReference;
    },

    /**
     * @method isImageReferenceNotSet
     * @param imageName {String} the name of the image to check if it has not been set.
     * @return {Boolean} true if the image configuration does not exist or the reference hasn't completed fetching.
     */
    isImageReferenceNotSet: function(imageName) {
      var imageReference = this.data.getModel(imageName);
      var imageReferenceNotSet = _.isUndefined(imageReference);
      if (_.isFunction(this.view.isPreview) && _.isFunction(this.view.isImagePreviewNotSet) && this.view.isPreview()) {
        imageReferenceNotSet = this.view.isImagePreviewNotSet(imageName);
      }
      return imageReferenceNotSet;
    }
  });
}));
